import styled from '@emotion/styled'
import { tracking } from '@vivaldis/tracking'
import { useCallback, useMemo } from 'react'
import {
  Button,
  Dropdown,
  TextStylePreset,
  Typography
} from '@vivaldis/antd-ui'
import { ArrowDown2 } from '@vivaldis/icons'
import { useUser } from '@vivaldis/session'
import { selectCompanyMutation } from '../../../../../../graphql/mutations/selectCompanyMutation'

export const CompanySelect = () => {
  const user = useUser()

  const permissions = useMemo(
    () => user?.permissions || [],
    [user?.permissions]
  )

  const handleMenuItemClick = useCallback(
    async (item: any) => {
      const { key } = item

      if (key !== user?.company?.id) {
        try {
          await selectCompanyMutation({
            companyId: String(key)
          })
        } catch (error) {
          tracking.error(error)
        }
      }
    },
    [user?.company?.id]
  )

  const menuItems = useMemo(
    () =>
      permissions.map(permission => ({
        key: permission.companyId,
        label: permission.companyName
      })),
    [permissions]
  )

  if (permissions.length < 2) {
    return (
      <Base>
        <Typography.Text
          preset={TextStylePreset.Semibold16}
          ellipsis
          style={{ maxWidth: 180 }}
        >
          {user?.company?.name}
        </Typography.Text>
      </Base>
    )
  }

  // we show this only when user has multiple companies
  return (
    <Dropdown
      menu={{
        onClick: handleMenuItemClick,
        items: menuItems,
        style: {
          maxHeight: 'calc(100vh - 200px)'
        }
      }}
    >
      <Button
        type="default"
        shape="round"
        size="large"
        icon={<ArrowDown2 />}
        iconPlacement="end"
      >
        <Typography.Text
          preset={TextStylePreset.Semibold16}
          ellipsis
          style={{ maxWidth: 180 }}
        >
          {user?.company?.name}
        </Typography.Text>
      </Button>
    </Dropdown>
  )
}

const Base = styled('div')`
  height: 40px;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 4px 12px;
  border-radius: 9999px;
  border: 1px solid ${props => props.theme.gray5};
`
